import { useCallback, useEffect, useRef } from 'react'

// @TODO: refactor the Value type to be more specific instead of any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebounceCallback = <Value extends any[]>(callback: (...value: Value) => void, delay = 250) => {
	const valueRef = useRef<Value>()
	const timeout = useRef<ReturnType<typeof setTimeout>>()

	const cleanup = () => {
		if (timeout.current) {
			clearTimeout(timeout.current)
		}
	}

	useEffect(() => cleanup, [])

	return useCallback(
		(value: Value) => {
			// capture latest values
			valueRef.current = value

			// clear debounce timer
			cleanup()

			timeout.current = setTimeout(() => {
				if (valueRef.current) {
					callback(...valueRef.current)
				}
			}, delay)
		},
		[callback, delay],
	)
}
